class VindiWizard {
    constructor() {
        this.currentStep = this.detectCurrentStep();
        this.formData = {};
        this.init();
    }

    detectCurrentStep() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page');
        const step = urlParams.get('step');

        if (page !== 'vindi-wizard') {
            return null;
        }

        return step || 'welcome';
    }

    init() {
        if (!this.currentStep) {
            return;
        }

        this.initStepSpecific();

        this.setupBackButton();
    }

    initStepSpecific() {
        switch (this.currentStep) {
            case 'register':
                this.setupPersonTypeToggle();
                this.setupFormSubmission();
                this.setupDocumentMasks();
                break;

            case 'address':
                this.loadSavedData();
                this.setupFormSubmission();
                this.setupDocumentMasks();
                break;

            case 'welcome':
                break;

            case 'login':
                break;

            case 'token':
                break;

            case 'features':
                this.setupFeatureToggles();
                this.setupFormSubmission();
                break;

            case 'success':
                break;
        }
    }

    setupFeatureToggles() {
        const toggles = document.querySelectorAll('.vindi-wizard-switch input[type="checkbox"]');

        toggles.forEach(toggle => {
            toggle.addEventListener('change', (e) => {
                console.log('Feature toggle changed:', e.target.checked);
            });
        });

        this.setupCancelRefundToggle();
    }

    setupCancelRefundToggle() {
        const cancelRefundToggle = document.getElementById('vindi-wizard-enable-cancel-refund');
        const refundFields = document.getElementById('vindi-wizard-refund-fields');
        const consumerKeyInput = document.getElementById('vindi-wizard-consumer-key');
        const consumerSecretInput = document.getElementById('vindi-wizard-consumer-secret');
        const authorizeBtn = document.getElementById('vindi-wizard-authorize-btn');

        if (!cancelRefundToggle || !refundFields) {
            return;
        }

        const toggleRefundFields = () => {
            refundFields.style.display = cancelRefundToggle.checked ? 'block' : 'none';
        };

        const validateAuthorizeButton = () => {
            if (!authorizeBtn) return;

            const isValid = consumerKeyInput.value.trim() !== '' && consumerSecretInput.value.trim() !== '';
            authorizeBtn.disabled = !isValid;
            authorizeBtn.title = isValid
                ? 'Clique para autorizar'
                : 'Preencha a Consumer Key e Consumer Secret para habilitar a autorização';
        };

        cancelRefundToggle.addEventListener('change', toggleRefundFields);

        if (consumerKeyInput && consumerSecretInput) {
            consumerKeyInput.addEventListener('input', validateAuthorizeButton);
            consumerSecretInput.addEventListener('input', validateAuthorizeButton);
        }

        if (authorizeBtn) {
            authorizeBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleAuthorization();
            });
        }

        toggleRefundFields();
        validateAuthorizeButton();
    }

    handleAuthorization() {
        const consumerKey = document.getElementById('vindi-wizard-consumer-key').value;
        const consumerSecret = document.getElementById('vindi-wizard-consumer-secret').value;

        if (!consumerKey || !consumerSecret) {
            alert('Por favor, preencha Consumer Key e Consumer Secret antes de autorizar.');
            return;
        }

        const form = document.querySelector('.vindi-wizard-functionalities');
        if (form) {
            const formData = new FormData(form);
            formData.set('save_credentials', '1');

            fetch(window.location.href, {
                method: 'POST',
                body: formData
            }).then(() => {
                const environment = vindiWizardConfig.environment || 'sandbox';
                const authorizationUrl = environment === 'sandbox'
                    ? vindiWizardConfig.sandboxAuthorizationUrl
                    : vindiWizardConfig.authorizationUrl;

                const callbackUrl = window.location.origin + '/wp-admin/admin.php?page=vindi-wizard&step=features&authorized=1';
                const encodedCallback = encodeURIComponent(callbackUrl);

                window.open(`${authorizationUrl}?consumer_key=${consumerKey}&url_retorno=${encodedCallback}`, '_blank');
            }).catch(error => {
                console.error('Error saving credentials:', error);
                alert('Erro ao salvar credenciais. Tente novamente.');
            });
        }
    }

    setupPersonTypeToggle() {
        const personTypeSelect = document.getElementById('vindi-person-type');
        const cpfField = document.getElementById('cpf-field');
        const cnpjField = document.getElementById('cnpj-field');
        const companyField = document.getElementById('company-field');

        if (personTypeSelect) {
            personTypeSelect.addEventListener('change', (e) => {
                const isPF = e.target.value === '1';

                if (isPF) {
                    cpfField.style.display = 'block';
                    cnpjField.style.display = 'none';
                    companyField.style.display = 'none';
                } else {
                    cpfField.style.display = 'none';
                    cnpjField.style.display = 'block';
                    companyField.style.display = 'block';
                }
            });
        }
    }

    setupDocumentMasks() {
        const cpfInput = document.querySelector('input[name="vindi-pagamentos-cpf"]');
        const cnpjInput = document.querySelector('input[name="vindi-pagamentos-cnpj"]');
        const phoneInput = document.querySelector('input[name="vindi-pagamentos-telefone"]');
        const cepInput = document.querySelector('input[name="vindi-pagamentos-cep"]');

        if (cpfInput && typeof IMask !== 'undefined') {
            IMask(cpfInput, { mask: '000.000.000-00' });
        }

        if (cnpjInput && typeof IMask !== 'undefined') {
            IMask(cnpjInput, { mask: '**.***.***/****-00' });
        }

        if (phoneInput && typeof IMask !== 'undefined') {
            IMask(phoneInput, { mask: '(00) 0 0000-0000' });
        }

        if (cepInput && typeof IMask !== 'undefined') {
            IMask(cepInput, { mask: '00000-000' });
        }
    }

    setupFormSubmission() {
        const submitButton = document.querySelector('.vindi-wizard-btn');
        const continueButton = document.querySelector('.vindi-wizard-continue');

        if (submitButton) {
            submitButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleFormSubmit();
            });
        }

        if (continueButton) {
            continueButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleFeaturesSubmit();
            });
        }
    }

    setupBackButton() {
        const backButton = document.querySelector('.vindi-wizard-back-btn');

        if (backButton) {
            backButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleBackStep();
            });
        }
    }

    validateForm() {
        if (this.currentStep === 'register') {
            return this.validateRegisterStep();
        } else if (this.currentStep === 'address') {
            return this.validateAddressStep();
        }
        return false;
    }

    validateRegisterStep() {
        const requiredFields = [
            'vindi-pagamentos-nome',
            'vindi-pagamentos-email',
            'vindi-pagamentos-telefone'
        ];

        const personType = document.querySelector('select[name="vindi-pagamentos-person-type"]')?.value;

        if (personType === '1') {
            requiredFields.push('vindi-pagamentos-cpf');
        } else if (personType === '2') {
            requiredFields.push('vindi-pagamentos-cnpj', 'vindi-pagamentos-social-name');
        }

        const termsAcceptedInput = document.querySelector('input[name="vindi-pagamentos-accept-terms"]');

        if (termsAcceptedInput && !termsAcceptedInput.checked) {
            alert('Você deve aceitar os termos e condições para continuar.');
            return false;
        }

        for (const fieldName of requiredFields) {
            const field = document.querySelector(`input[name="${fieldName}"], select[name="${fieldName}"]`);
            if (!field || !field.value.trim()) {
                alert(`Por favor, preencha o campo: ${this.getFieldLabel(fieldName)}`);
                field?.focus();
                return false;
            }
        }

        return true;
    }

    validateAddressStep() {
        const requiredFields = [
            'vindi-pagamentos-cep',
            'vindi-pagamentos-endereco',
            'vindi-pagamentos-numero',
            'vindi-pagamentos-bairro',
            'vindi-pagamentos-cidade',
            'vindi-pagamentos-estado'
        ];

        for (const fieldName of requiredFields) {
            const field = document.querySelector(`input[name="${fieldName}"], select[name="${fieldName}"]`);
            if (!field || !field.value.trim()) {
                alert(`Por favor, preencha o campo: ${this.getFieldLabel(fieldName)}`);
                field?.focus();
                return false;
            }
        }

        return true;
    }

    getFieldLabel(fieldName) {
        const labels = {
            'vindi-pagamentos-nome': 'Nome',
            'vindi-pagamentos-email': 'E-mail',
            'vindi-pagamentos-telefone': 'Telefone',
            'vindi-pagamentos-cpf': 'CPF',
            'vindi-pagamentos-cnpj': 'CNPJ',
            'vindi-pagamentos-social-name': 'Razão Social',
            'vindi-pagamentos-cep': 'CEP',
            'vindi-pagamentos-endereco': 'Endereço',
            'vindi-pagamentos-numero': 'Número',
            'vindi-pagamentos-bairro': 'Bairro',
            'vindi-pagamentos-cidade': 'Cidade',
            'vindi-pagamentos-estado': 'Estado'
        };
        return labels[fieldName] || fieldName;
    }

    collectFormData() {
        const formData = {};
        const inputs = document.querySelectorAll('input[name^="vindi-pagamentos-"], select[name^="vindi-pagamentos-"]');

        inputs.forEach(input => {
            if (input.type === 'checkbox') {
                formData[input.name] = input.checked;
            } else {
                formData[input.name] = input.value;
            }
        });

        return formData;
    }

    handleFeaturesSubmit() {
        const features = {};
        const toggles = document.querySelectorAll('.vindi-wizard-switch input[type="checkbox"]');

        toggles.forEach((toggle, index) => {
            const featureNames = ['pix', 'credit', 'billet', 'bolepix', 'multipayment'];
            if (featureNames[index]) {
                features[featureNames[index]] = toggle.checked;
            }
        });

        localStorage.setItem('vindi-wizard-features', JSON.stringify(features));
        window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=success`;
    }

    async handleFormSubmit() {
        if (!this.validateForm()) {
            return;
        }

        const formData = this.collectFormData();
        this.formData = { ...this.formData, ...formData };

        if (this.currentStep === 'register') {
            this.navigateToAddressStep();
        }
        else if (this.currentStep === 'address') {
            await this.submitToAPI();
        }
    }

    navigateToAddressStep() {
        localStorage.setItem('vindi-wizard-data', JSON.stringify(this.formData));
        window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=address`;
    }

    async submitToAPI() {
        try {
            const response = await this.callYapayAPI();

            if (response.success) {
                window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=token`;
            } else {
                alert('Erro ao criar conta: ' + response.message);
            }
        } catch (error) {
            console.error('Erro:', error);
            alert('Erro ao criar conta. Tente novamente.');
        }
    }

    async callYapayAPI() {
        const formData = new FormData();
        formData.append('action', 'vindi_create_user_account');
        formData.append('nonce', vindiWizardConfig.nonce);
        formData.append('wizard_data', JSON.stringify(this.formData));

        const response = await fetch(vindiWizardConfig.ajaxUrl, {
            method: 'POST',
            body: formData
        });

        return await response.json();
    }

    handleBackStep() {
        if (this.currentStep === 'address') {
            window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=register`;
        } else if (this.currentStep === 'register') {
            window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=welcome`;
        } else if (this.currentStep === 'features') {
            window.location.href = `${window.location.origin}/wp-admin/admin.php?page=vindi-wizard&step=token`;
        }
    }

    loadSavedData() {
        const savedData = localStorage.getItem('vindi-wizard-data');
        if (savedData) {
            this.formData = JSON.parse(savedData);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new VindiWizard();
});